import styles from "Styles/CompanySize.module.css"
import dots from "Assets/dots.png"
import InfoContentMotionWrapper from 'Components/MotionWrapper/InfoContentMotionWrapper';
import { renderFormattedText } from "Lib/text-utils";

export default function CompanySizeInfoContent({heading = "請問 hububble 有多少員工？"}) {
	return (
		<InfoContentMotionWrapper>
			<h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
			<div className={styles.imageWrapper}>
				<img className={styles.image} src={dots} alt="" />
			</div>
		</InfoContentMotionWrapper>
	)
}
